import type { ReactNode } from 'react';
import { useMemo } from 'react';

import type { Persona } from '../../../../domain/persona';

import { PersonaTooltipContent } from './PersonaTooltipContent';
import { StyledTooltip } from './styles';

type PersonaTooltipProps = {
  persona: Persona;
  children: ReactNode;
};

const toList = (arr?: string[] | null) => (Array.isArray(arr) ? arr.filter((s) => s && s.trim() !== '') : []);

export const PersonaTooltip = ({ persona, children }: PersonaTooltipProps) => {
  const fields = useMemo(
    () =>
      [
        { labelKey: 'department', value: toList(persona.departments) },
        { labelKey: 'seniority', value: toList(persona.seniority) },
        { labelKey: 'include_titles', value: toList(persona.includeTitles) },
        { labelKey: 'exclude_titles', value: toList(persona.excludeTitles) },
      ].filter(({ value }) => value.length > 0),
    [persona]
  );

  const hasContent = fields.length > 0;

  return (
    <StyledTooltip enabled={hasContent} content={hasContent ? <PersonaTooltipContent fields={fields} /> : null}>
      {children}
    </StyledTooltip>
  );
};
